import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component, isValidElement, cloneElement } from 'react';
import { focusElement, preventPasteFile } from '../utils/dom/element';
import { treeSelectClass } from './styles';
var DefaultValue = {
  text: '',
  updatAble: false
};

var FilterInput =
/*#__PURE__*/
function (_Component) {
  _inherits(FilterInput, _Component);

  var _super = _createSuper2(FilterInput);

  function FilterInput(props) {
    var _this;

    _classCallCheck(this, FilterInput);

    _this = _super.call(this, props);
    _this.editElement = void 0;
    _this.blurTimer = void 0;
    _this.handleBlur = void 0;
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    _this.handleInput = _this.handleInput.bind(_assertThisInitialized(_this)); // for mutiple select

    _this.props.setInputReset(_this.reset.bind(_assertThisInitialized(_this)));

    return _this;
  }

  _createClass(FilterInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.focus) {
        this.focus();
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return this.props.updatAble;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.focus === prevProps.focus || !this.props.focus) return;
      this.focus();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.editElement) this.editElement.innerText = '';
      if (this.blurTimer) clearTimeout(this.blurTimer);
    }
  }, {
    key: "focus",
    value: function focus() {
      var _this2 = this;

      requestAnimationFrame(function () {
        focusElement.select(_this2.editElement);
      });
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      this.editElement = el;
    }
  }, {
    key: "handleInput",
    value: function handleInput(e) {
      this.props.onFilter(e.target.innerText.replace('\feff ', '').trim());
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          text = _this$props.text,
          focus = _this$props.focus,
          multiple = _this$props.multiple;
      var value = typeof text === 'string' ? text.replace(/<\/?[^>]*>/g, '') : text;

      if (
      /*#__PURE__*/
      isValidElement(value)) {
        return (
          /*#__PURE__*/
          cloneElement(value, {
            className: treeSelectClass('input'),
            ref: this.bindElement,
            key: 'input',
            onInput: this.handleInput,
            contentEditable: focus
          })
        );
      }

      return (
        /*#__PURE__*/
        React.createElement("span", {
          key: "input",
          className: treeSelectClass('input', !multiple && 'full'),
          ref: this.bindElement,
          contentEditable: focus,
          onPaste: preventPasteFile,
          onInput: this.handleInput,
          onBlur: this.handleBlur,
          dangerouslySetInnerHTML: {
            __html: value
          }
        })
      );
    }
  }]);

  return FilterInput;
}(Component);

FilterInput.defaultProps = DefaultValue;
export default FilterInput;